import styled from 'styled-components';

export const FormContainer = styled.div`
	gap: 16px;
	width: 100%;
	max-width: 800px;
	margin: 0 auto;
`;
